import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import "./index.css";
import { cToF } from "../../utils";
import Switch from "react-switch";
import { LoadSettingAck } from "../../store/backend";


type SetTemperatureProps = {
  value: number;
  onTouchEnd?(value: number): void;
  style?: React.CSSProperties | undefined;
  rangeData?: number[];
  min?: number;
  max?: number;
  unit?: 'C' | 'F' | undefined
  title: string
  type: 'temperature' | 'humidity'

  humidityEnabled?: boolean
  humidityDisabled?: boolean
  onChangeHumidityEnabled?(value: SetTemperatureProps['humidityEnabled']): void
  systemVersion: LoadSettingAck['data']['systemVersion']

};

function SetTemperature(props: SetTemperatureProps) {
  // 滑杆使用离散温度档位，鼠标和触摸最终都要提交到同一条回调链路。
  const validValues = useMemo(() => props.rangeData || [], [props.rangeData]);
  const [index, setIndex] = useState(0);
  const lastCommittedIndexRef = useRef<number | null>(null);

  const safeIndex = useMemo(() => {
    if (!validValues.length) {
      return 0;
    }
    return Math.min(Math.max(index, 0), validValues.length - 1);
  }, [index, validValues]);

  const value = validValues[safeIndex];

  const onChange = (event: any) => {
    const newValueIndex = Number(event.target.value);
    setIndex(Number.isFinite(newValueIndex) ? newValueIndex : 0);
  };

  const commitValue = useCallback(() => {
    if (!props.onTouchEnd || !validValues.length) {
      return;
    }

    if (lastCommittedIndexRef.current === safeIndex) {
      return;
    }

    lastCommittedIndexRef.current = safeIndex;
    props.onTouchEnd(validValues[safeIndex]);
  }, [props, safeIndex, validValues]);

  const unit = props.type === 'temperature'
    ? props.unit === 'F' ? '℉' : '℃'
    : '%'

  useEffect(() => {
    const nextIndex = validValues.indexOf(props.value);
    const resolvedIndex = nextIndex >= 0 ? nextIndex : 0;
    setIndex(resolvedIndex);
    lastCommittedIndexRef.current = resolvedIndex;
  }, [props.value, validValues]);

  return (
    <div
      style={{
        display: 'grid',
        position: 'relative',
      }}
    >
      <div
        className="flex text-white border-2 border-white rounded-3xl   bg-quickStartLeftStepContentBgColor"
        style={{
          ...(props.style || {}),
          height: 125,
          flexDirection: 'column',
          justifySelf: 'flex-start',
          justifyContent: 'center',
          boxShadow: "3px 3px 3px  rgba(0, 0, 0, 0.3)",
          opacity: props.type === 'humidity' ?
            props.humidityEnabled ? 1 : 0.5
            : 1,
        }}
      >
        <div
          style={{
            // fontFamily: 'Roboto',
            fontWeight: 700,
            fontSize: '32px',
            lineHeight: '100%',
            letterSpacing: '0%',
            textAlign: 'center',
          }}
        >{props.title}</div>

        <div className="flex"
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            marginLeft: 30,
            marginRight: 30,
          }}
        >
          <div
            style={{
              marginRight: 30,
              position: 'relative',
            }}
          >

            <div
              className="flex"
              style={{
                fontWeight: 400,
                fontSize: 18,
                textAlign: 'center',
                position: 'absolute',
                width: '100%',
                justifyContent: 'space-between',
                left: 0,
                top: 28,
                opacity: 0.5,
              }}
            >
              <span>
                {unit === '℉' ? cToF(validValues[0]) : validValues[0]}{unit}
              </span>
              <span
              >
                +{unit === '℉' ? cToF(validValues[validValues.length - 1]) : validValues[validValues.length - 1]}{unit}
              </span>
            </div>

            <input
              className={props.type === 'temperature' ? "set-temperature-range" : 'set-humidity-range'}
              type="range"
              value={index}
              min={0}
              max={validValues.length - 1}
              onChange={onChange}

              onMouseUp={commitValue}
              onPointerUp={commitValue}
              onTouchEnd={commitValue}
              step={1}
            />

          </div>

          <div
            style={{
              width: 170,
              fontWeight: 600,
              fontSize: 50,
              lineHeight: '100%',
              textAlign: 'center'
            }}
          >
            {(unit === '℉' ? cToF(value) : value) + unit}
          </div>

          {props.type === 'humidity' && props.systemVersion === 'HBP02GA' && (
            <div
              style={{
                transform: `scale(1.5)`,
                marginBottom: 23,
                marginLeft: 50,
              }}
            >
              <div
                style={{
                  height: 28,
                  width: 28 * 1.7
                }}
              />
            </div>
          )}

        </div>

      </div >

      {props.type === 'humidity' && props.systemVersion === 'HBP02GA' && (
        <div
          style={{
            transform: `scale(1.5)`,
            position: 'absolute',
            top: 71,
            right: 92,

          }}
        >
          <div
            style={{
              position: 'absolute',
            }}
          >

            <Switch
              disabled={props.humidityDisabled}
              onChange={value => props.onChangeHumidityEnabled && props.onChangeHumidityEnabled(value)}
              checked={!!props.humidityEnabled}
              uncheckedIcon={false}
              checkedIcon={false}
              onColor={"#5ede4e"}
              height={28}
              width={28 * 1.7}
            />
          </div>

        </div>
      )}
    </div>

  );
}
export default SetTemperature;
